import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getBaseMenuTree, getMenuAuthority, addMenuAuthority } from '@/api/menu';
import { updateAuthority } from '@/api/authority';
export default {
  name: 'Menus',
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  data: function data() {
    return {
      menuTreeData: [],
      menuTreeIds: [],
      needConfirm: false,
      menuDefaultProps: {
        children: 'children',
        label: function label(data) {
          return data.meta.title;
        }
      }
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res, res1, menus, arr;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return getBaseMenuTree();
          case 1:
            res = _context.sent;
            _this.menuTreeData = res.data.menus;
            _context.next = 2;
            return getMenuAuthority({
              authorityId: _this.row.authorityId
            });
          case 2:
            res1 = _context.sent;
            menus = res1.data.menus;
            arr = [];
            menus.map(function (item) {
              // 防止直接选中父级造成全选
              if (!menus.some(function (same) {
                return same.parentId === item.menuId;
              })) {
                arr.push(Number(item.menuId));
              }
            });
            _this.menuTreeIds = arr;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    setDefault: function setDefault(data) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return updateAuthority({
                authorityId: _this2.row.authorityId,
                AuthorityName: _this2.row.authorityName,
                parentId: _this2.row.parentId,
                defaultRouter: data.name
              });
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.$message({
                  type: 'success',
                  message: '设置成功'
                });
                _this2.row.defaultRouter = res.data.authority.defaultRouter;
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    nodeChange: function nodeChange() {
      this.needConfirm = true;
    },
    // 暴露给外层使用的切换拦截统一方法
    enterAndNext: function enterAndNext() {
      this.relation();
    },
    // 关联树 确认方法
    relation: function relation() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var checkArr, res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              checkArr = _this3.$refs.menuTree.getCheckedNodes(false, true);
              _context3.next = 1;
              return addMenuAuthority({
                menus: checkArr,
                authorityId: _this3.row.authorityId
              });
            case 1:
              res = _context3.sent;
              if (res.code === 0) {
                _this3.$message({
                  type: 'success',
                  message: '菜单设置成功!'
                });
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};